<template lang="pug">
    div
        Card.group-card
            p(slot="title")
                Icon(type="md-contacts")
                |
                | Groups
            p(slot="extra" v-if="$store.state.queryGroupName == 'all'") Select a group to start managing
            Input(v-model="searchGroupKeyword" placeholder="Search your group" style="padding-bottom: 12px;")
            Row(:gutter="16")
                RadioGroup(:value="$store.state.queryGroupName" @on-change="setGroupName" :style="{'width': '100%','display': 'flex','flex-wrap': 'wrap'}")
                    Col(:lg="8" :md="12" :style="{'padding-top': '4px'}" v-for="groupName in filteredGroupNames" :key="groupName" )
                        Radio(:label="groupName" border :style="{'width': '100%','overflow-y': 'auto'}")

            //- RadioGroup(:value="$store.state.queryGroupName" @on-change="setGroupName")
            //-     template(v-for="groupName in filteredGroupNames")
            //-         Radio(:label="groupName" style="width:250px; overflow: hidden;" border)
                // Col(span="4" v-for="groupName in $store.getters.inGroupNames" :key="groupName")
                //     a(@click="setGroupName") {{ groupName }}

</template>
<script>
import bus from "@/libs/bus.js";
export default {
    name: "GroupCard",
    props: [],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return { searchGroupKeyword: "" };
    },
    methods: {
        setGroupName(groupName) {
            bus.$emit("SET_QUERY_GROUPNAME", groupName);
        }
    },
    mounted() {},
    computed: {
        filteredGroupNames() {
            return this.$store.getters.inGroupNames.filter(groupName => groupName.includes(this.searchGroupKeyword));
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home/GroupCard.vue